import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M12.131 9.75H3.75a.73.73 0 0 1-.535-.216A.72.72 0 0 1 3 9q0-.319.216-.535a.72.72 0 0 1 .534-.215h8.381L8.456 4.575a.69.69 0 0 1-.216-.525.75.75 0 0 1 .235-.525A.8.8 0 0 1 9 3.309q.3-.01.525.216l4.95 4.95a.7.7 0 0 1 .16.244.8.8 0 0 1 .046.281q0 .15-.047.281a.7.7 0 0 1-.159.244l-4.95 4.95a.7.7 0 0 1-.515.206.77.77 0 0 1-.535-.206.73.73 0 0 1-.225-.535q0-.309.225-.534z"
    }, null, -1)
  ]))]))
}
export default { render: render }